export default function Footer() {
  return (
    <footer className="bg-[#103c2c] text-white py-3 text-center">
      <p>
        © {new Date().getFullYear()} EventIQ. All rights reserved.
      </p>
    </footer>
  );
}
